import React, { Component } from 'react';

const FrontPage = ({ history }) => {
  return (
    <div className="FrontPageContainer">
      <div className="FrontPage">
        <h1 className="animated fadeIn"><span className="in">in</span>vidia</h1>
        <h2 className="animated fadeIn delay">Search videos based on what's actually said inside of it.</h2>
        <form className="animated fadeIn delay" onSubmit={(e) => {
          e.preventDefault();
          const query = e.target.search.value;
          history.push({
            pathname: '/search',
            search: '?q=' + query,
          });
        }}>
          <input type="text" id="search" placeholder="Search anything..." />
          <button>Search</button>
        </form>
      </div>
    </div>
  );
};

export default FrontPage;



// WEBPACK FOOTER //
// ./src/FrontPage.js